import { render } from "./PlanesPage.vue?vue&type=template&id=74f46830"
import script from "./PlanesPage.vue?vue&type=script&lang=js"
export * from "./PlanesPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__